/* eslint-disable prettier/prettier */
import React from 'react';
import Joyride, { Step, FloaterProps, CallBackProps, ACTIONS, LIFECYCLE } from 'react-joyride';

import { withTheme } from 'styled-components';

import CancelableTootip from '../Tooltips/Cancelable';
import InfomationTootips from '../Tooltips/Information';

interface Props {
  theme?: any;
  show: boolean;
  hideArrow: boolean;
  steps?: Step[];
  onClose?: () => void;
  disableScrollParentFix?: boolean;
  disableOverlayClose?: boolean;
  type: 'cancelable' | 'information';
  scrollToFirstStep?: boolean;
  scrollOffset?: number;
  index?: number;
}

const Tour = ({
  show,
  hideArrow,
  steps,
  index,
  onClose,
  disableOverlayClose,
  disableScrollParentFix,
  type,
  scrollToFirstStep,
  scrollOffset,
  theme,
}: Props) => {
  const options = {
    arrowColor: theme.joyRide.arrow,
  };

  const listenerActionsInfo = (data: CallBackProps) => {
    const { action, lifecycle } = data;

    if (ACTIONS.CLOSE === action && LIFECYCLE.COMPLETE === lifecycle) {
      onClose && onClose();
    }
  };

  const listenerActionsCancelableTooltip = (action: string) => {
    if (action === 'close') {
      onClose && onClose();
    }
  };

  return (
    <Joyride
      run={show}
      steps={steps}
      stepIndex={index}
      callback={(props) =>
        type === 'cancelable' ? listenerActionsCancelableTooltip(props.action) : listenerActionsInfo(props)
      }
      disableScrollParentFix={disableScrollParentFix}
      disableOverlayClose={disableOverlayClose}
      scrollToFirstStep={scrollToFirstStep}
      styles={{
        options,
        spotlight: {
          backgroundColor: '#0000001f',
        },
      }}
      scrollOffset={scrollOffset}
      floaterProps={{ hideArrow } as unknown as FloaterProps}
      tooltipComponent={({ ...props }) =>
        type === 'cancelable' ? <CancelableTootip {...props} /> : <InfomationTootips {...props} />
      }
    />
  );
};

export default withTheme(Tour);
